import React from "react";
import { Eye } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../../ui/Popover";
import { Switch } from "../../ui/Switch";
import { Label } from "../../ui/Label";

export type LayerVisibilityState = {
  bsRange: boolean;
  fsRange: boolean;
  poiRange: boolean;
};

interface LayerVisibilityMenuProps {
  layerVisibility: LayerVisibilityState;
  onToggle: (key: keyof LayerVisibilityState) => void;
}

const LAYERS: { key: keyof LayerVisibilityState; label: string }[] = [
  { key: "bsRange", label: "Background Sound Ranges" },
  { key: "fsRange", label: "Focused Sound Ranges" },
  { key: "poiRange", label: "POI Ranges" },
];

export function LayerVisibilityMenu({ layerVisibility, onToggle }: LayerVisibilityMenuProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button className="flex items-center justify-center w-8 h-8 rounded bg-black/60 text-white hover:bg-black/80 transition-colors">
          <Eye size={16} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-52 p-3 space-y-3">
        <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          Layer Visibility
        </p>
        {LAYERS.map(({ key, label }) => (
          <div key={key} className="flex items-center justify-between gap-3">
            <Label htmlFor={key} className="text-sm cursor-pointer">
              {label}
            </Label>
            <Switch
              id={key}
              checked={layerVisibility[key]}
              onCheckedChange={() => onToggle(key)}
            />
          </div>
        ))}
      </PopoverContent>
    </Popover>
  );
}
